import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class SelectBox extends Component{
	constructor(props){
		super(props);
		this.handleChoice = this.handleChoice.bind(this);
	}

	handleChoice(e){ //method for handling user selection/change
		let choice = e.target.value;
		this.props.onSelect(this.props.identity,choice);
	}

	render(){
		let disable;
		if(this.props.disable){
			disable = true;
		}else{
			disable = false;
		}
		let options = this.props.options;
		let firstOp;
		if(this.props.type !== "text"){ //optional prop type allows for first disabled option to be something other than "Select"
			firstOp = this.props.type;
		}else{
			firstOp = "Select";
		}
		const select = options.map((options,i)=> { //map out options
      return (
        <option key={i} value={options}>{options}</option>
      )
    });

		return(
			<div>
				<select className={this.props.styles} onChange={this.handleChoice} value={this.props.val} disabled={disable}><option disabled={true}>{firstOp}</option>{select}</select>
			</div>
		);
	}
}
SelectBox.defaultProps = {
  type: 'text'
};

SelectBox.propTypes = {
	disable: PropTypes.bool,
	options: PropTypes.array.isRequired,
	type: PropTypes.string,
	val: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number
	]),
	onSelect: PropTypes.func.isRequired,
	styles: PropTypes.string,
	identity: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/component/Select.js